export default {
  stoplight: {
    concernOptions: [],
    scotsworkConcerns: []
  },
  alert: {
    term: ''
  }
}
